import _ from 'lodash';
import paginationTemplate from './pagination.html';

class PaginationController {
  gotoPage(newPage, oldPage) {
    if (newPage === '') {
      return;
    }
    newPage *= 1;
    oldPage *= 1;
    if (!_.isNumber(newPage) || newPage < 1 || newPage > this.gridMeta.pagesCount) {
      this.gridMeta.displayedPage = oldPage;
      this.gridMeta.page = --oldPage;
      return;
    }
    this.onGotoPage({
      page: --newPage,
    });
  }

  nextPage() {
    if (this.gridMeta.hasNextPage) {
      this.onNextPage();
    }
  }

  prevPage() {
    if (this.gridMeta.hasPreviousPage) {
      this.onPrevPage();
    }
  }
}

export default class PaginationComponent {
  constructor() {
    this.bindings = {
      gridMeta: '=',
      defaultFirstPage: '=',
      pageSizeValues: '=',
      onPrevPage: '&',
      onNextPage: '&',
      onGotoPage: '&',
      onPageSizeChange: '&',
      idPrefix: '@',
    };
    this.template = paginationTemplate;
    this.controller = PaginationController;
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/grid/pagination-component.js